import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { LIFECYCLE_STAGES } from './CustomerList';

export const AddCustomerModal = ({ open, onOpenChange, customer, setCustomer, onSave, isSaving }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="add-customer-modal" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Add New Customer</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Name *</Label>
            <Input value={customer.name} onChange={(e) => setCustomer(c => ({ ...c, name: e.target.value }))} placeholder="Customer name" />
          </div>
          <div className="space-y-2">
            <Label>Mobile *</Label>
            <Input value={customer.mobile} onChange={(e) => setCustomer(c => ({ ...c, mobile: e.target.value }))} placeholder="+27..." />
          </div>
          <div className="space-y-2">
            <Label>Email</Label>
            <Input type="email" value={customer.email} onChange={(e) => setCustomer(c => ({ ...c, email: e.target.value }))} placeholder="email@example.com" />
          </div>
          <div className="space-y-2">
            <Label>Address</Label>
            <Input value={customer.primary_address} onChange={(e) => setCustomer(c => ({ ...c, primary_address: e.target.value }))} placeholder="Primary address" />
          </div>
          <div className="space-y-2">
            <Label>Lifecycle Stage</Label>
            <Select value={customer.lifecycle_stage} onValueChange={(v) => setCustomer(c => ({ ...c, lifecycle_stage: v }))}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                {LIFECYCLE_STAGES.map(stage => (
                  <SelectItem key={stage.value} value={stage.value}>{stage.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onSave} disabled={isSaving} data-testid="save-customer-btn">
            {isSaving && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
            Add Customer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
